/**
 * FAQ
 *
 * This is for faq flexible content section, and for the CRO FAQ block.
 */

import $ from 'jquery';

$(function () {
    $('.faq__question').click(function () {
        $(this).siblings('.faq__answer').slideToggle(300);
        $(this).find('.fa-chevron-down').toggle();
        $(this).find('.fa-chevron-up').toggle();
    });
});

/*
 * CRO FAQ: a <details> per question, so it opens and closes without any
 * script. This only animates that: the answer slides open and shut instead
 * of jumping. Without the Web Animations API, or with reduced motion asked
 * for, the browser's own instant toggle is left alone.
 */
const DURATION = 300;
const EASING = 'cubic-bezier(0.2, 0.7, 0.2, 1)';
const running = new WeakMap();

function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function slide(item, answer, open) {
    // Clicked again halfway: carry on from where the answer is now. A closed
    // <details> starts at 0: Chrome still lays out its hidden content, so
    // measuring it would give the full height and nothing to open.
    const from = item.open ? answer.getBoundingClientRect().height : 0;

    running.get(item)?.cancel();

    item.classList.toggle('is-open', open);
    item.classList.toggle('is-closing', !open);

    if (open) {
        item.open = true;
    }

    const to = open ? answer.scrollHeight : 0;
    const animation = answer.animate(
        [
            { height: `${from}px`, opacity: open ? 0 : 1 },
            { height: `${to}px`, opacity: open ? 1 : 0 },
        ],
        { duration: DURATION, easing: EASING }
    );

    running.set(item, animation);

    animation.onfinish = () => {
        running.delete(item);
        item.classList.remove('is-closing');

        if (!open) {
            item.open = false;
        }
    };
}

document.addEventListener('click', (event) => {
    const summary = event.target.closest('.cro-faq__question');

    if (!summary || reducedMotion()) {
        return;
    }

    const item = summary.parentElement;
    const answer = item.querySelector('.cro-faq__answer');

    if (!answer || typeof answer.animate !== 'function') {
        return;
    }

    event.preventDefault();
    slide(item, answer, !item.classList.contains('is-open') || item.classList.contains('is-closing'));
});

// Opened some other way (find in page, a link to the question): keep the
// chevron in step.
document.addEventListener('toggle', (event) => {
    const item = event.target;

    if (item.classList?.contains('cro-faq__item') && !running.has(item)) {
        item.classList.toggle('is-open', item.open);
    }
}, true);
